import { Grid } from '@mantine/core';

import { useGetReportPatientDetailsQuery } from '@/store/slices/api/transmissionReport/reportsPatientApiSlice';

import SkeletonGrid from '@/ui/Skeleton';

import DetailsSection from './components/DetailsSection';
import TabsSection from './components/TabsSection';
import styles from './PatientDetails.module.scss';

interface PatientDetailsProps {
  patientId: string;
}

const PatientDetails = ({ patientId }: PatientDetailsProps) => {
  const { isLoading: isPatientLoading, isError: isPatientError } = useGetReportPatientDetailsQuery(
    patientId,
    {
      skip: !patientId
    }
  );

  if (isPatientLoading) {
    return <SkeletonGrid height={80} columns={2} rows={1} />;
  }

  if (isPatientError) {
    return <div>Error loading Patient Details</div>;
  }

  return (
    <Grid className={styles.container}>
      <Grid.Col span={{ base: 12, md: 6.5 }}>
        <DetailsSection patientId={patientId} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 5.5 }}>
        <TabsSection patientId={patientId} />
      </Grid.Col>
    </Grid>
  );
};

export default PatientDetails;
